import { useContext } from "react";
import { ServerWalletContext } from "./context";
export function useServerWallet() {
  return useContext(ServerWalletContext);
}